<template>
    <div class="row">
        <div class="col-12">
            <h2 class="m-0 h1 text-uppercase">Elige tus asientos</h2>
            <h3 class="subtitle h3 light mb-3 " v-if="!select_disabled">Si lo deseas, también puedes escoger varios asientos a la vez</h3>
        </div>
        <div class="col-12 col-lg-6">
            <div class="oswald text-uppercase">Zona seleccionada:</div>
            <span class="h3 mb-4 mb-lg-2 d-flex justify-content-between align-items-end">
                {{ zona.name }}
                <!--
                <small class="h6 button small-button m-0" @click="mostrarCambiarZona ? mostrarCambiarZona = false : mostrarCambiarZona = true">
                    <i class="fa fa-redo"></i> Cambiar
                </small>-->

                <small class="h6 button small-button m-0" @click="volver">
                    <i class="fa fa-redo"></i> Cambiar Zona / Butacas
                </small>
            </span>
            <div v-if="zona.imagen && !mostrarCambiarZona" class="mb-3">
                <img :src="zona.imagen">
            </div>



            <SelectorZonaComponent v-if="mostrarCambiarZona" :zona="zona" :zonas="zonas" v-on:cambiarZona="cambiarZona"></SelectorZonaComponent>


            <!--<h3>{{ zona.precios[0].precio }} € ({{ zona.precios[0].descripcion }})</h3>-->

            <TusAsientosComponent :can_click="can_click"  v-if="zona.with_seats" :precios="zona.precios" :asientos="datos_compradores" v-on:continuar="terminar" :configuracion_valida="configuracion_valida"></TusAsientosComponent>
        </div>
        <div class="col-12 col-lg-6 order-first order-lg-last">
            <div v-if="zona.with_seats">
                <AsientosComponent :stock="abono_seleccionado ? abono_seleccionado.stock : 6" :zona="zona" :asientos="datos_compradores" v-on:actualizarDatos="actualizarDatos" v-on:continuar="terminar" :forzar_adyacentes="true" :can_click="can_click"></AsientosComponent>
            </div>
            <div  v-if="!zona.with_seats">
                <p class="oswald text-uppercase mt-lg-4">Seleccione el numero de abonos</p>
                <div class="form-group">
                    <multiselect
                        :disabled="select_disabled"
                        v-model="n_abonos"
                        placeholder="Seleccionar zona"
                        :show-labels="false"
                        :options="options"
                        :allow-empty="false"
                    ></multiselect>
                </div>
                <TusAsientosComponent :precios="zona.precios" :asientos="datos_compradores" v-on:continuar="terminar" :configuracion_valida="true" :can_click="can_click"></TusAsientosComponent>
            </div>


        </div>
    </div>
</template>

<script>
	import SelectorZonaComponent from '@/components/frontend/abonos/nuevo/SelectorZonaComponent';
	import TusAsientosComponent from '@/components/frontend/abonos/nuevo/TusAsientosComponent';
	import AsientosComponent from '@/components/frontend/abonos/nuevo/AsientosComponent';

    export default {
        props: ['zona', 'zonas', 'datos_compradores', 'can_click', 'abono_seleccionado'],
        data() {
            return {
                loading: false,
                mostrarCambiarZona: false,
                configuracion_valida: false
            }
        },
        computed: {
            select_disabled() {
                var dni = this.$route.query.dni;
                var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;

                if(dni && n_abonado_antiguo) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            terminar() {
                this.$emit('terminado', this.datos_compradores);
            },
            volver() {
            	this.$emit('volver');
            },
            actualizarDatos(datos, configuracion_valida) {
                this.datos_compradores = datos;
                this.configuracion_valida = configuracion_valida;
            },
        },
        components: {
        	SelectorZonaComponent, TusAsientosComponent, AsientosComponent
        }
    }
</script>
